module.exports = __webpack_public_path__ + "img/reports.92d01e9f.svg";